export const rulesLookupFieldDropdown =  [

];



// WEBPACK FOOTER //
// ./src/pages/collateralRules/filter/rulesLookupFieldDropdown.js